import _ from 'lodash';
import UAParser from 'ua-parser-js';
import config from 'config/';

const uaParser = new UAParser();

export const clgCodeValidation = (value) => /^[0-9]{12}$/i.test(value);

export const isMobile = ['mobile', 'tablet'].includes(uaParser.getDevice().type);

export const isSupportedOS = ['iOS', 'Android'].includes(uaParser.getOS().name);

export const isSafariMobile = ['Mobile Safari'].includes(uaParser.getBrowser().name);

export const basenameUrl = (url) => `${config.basename ? '/' : ''}${config.basename}${url}`;

const isGetUserMediaSupported = () =>
  !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) ||
  !!navigator.getUserMedia ||
  !!navigator.webkitGetUserMedia ||
  !!navigator.mozGetUserMedia;

export const isCameraEnabled = () => isMobile && isSupportedOS && isGetUserMediaSupported();

export const calcVh = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

export const setVh = () => {
  calcVh();
  window.addEventListener('resize', () => {
    calcVh();
  });
};

export const getImage = (image) => {
  const imageUrl = _.get(image, 'url');
  const provider = _.get(image, 'provider');
  const urlPrefix = provider === 'local' ? config.api.cms : '';
  return imageUrl ? `${urlPrefix}${imageUrl}` : '';
};

export default {
  calcVh,
  clgCodeValidation,
  getImage,
};
